import Icon from '../../../components/AppIcon';

const EmergencyResponseCTA = () => {
  const handleEmergencyCall = () => {
    window.location.href = 'tel:0827935785';
  };

  const responseFeatures = [
    {
      icon: "Clock",
      title: "&lt;60 Minutes",
      description: "Average response time for emergency calls"
    },
    {
      icon: "Calendar",
      title: "24/7 Available",
      description: "Round-the-clock emergency service"
    },
    {
      icon: "MapPin",
      title: "Wide Coverage",
      description: "Serving the greater region"
    },
    {
      icon: "Shield",
      title: "Guaranteed Work",
      description: "All emergency repairs warranted"
    }
  ];

  return (
    <section className="py-12 md:py-16 lg:py-24 bg-gradient-to-br from-accent via-accent/90 to-accent text-white relative overflow-hidden">
      <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1504328345606-18bbc8c9d7d1?w=1920')] bg-cover bg-center opacity-10"></div>
      <div className="relative max-w-7xl mx-auto px-4 lg:px-8">
        <div className="text-center mb-8 md:mb-12">
          <div className="inline-flex items-center gap-2 bg-white/20 backdrop-blur-sm px-4 py-2 rounded-full mb-4">
            <Icon name="AlertCircle" size={20} />
            <span className="text-sm md:text-base font-semibold">Emergency Service</span>
          </div>
          
          <h2 className="text-2xl md:text-3xl lg:text-5xl font-bold mb-4">
            Need Immediate Help?
          </h2>
          
          <p className="text-base md:text-lg lg:text-xl text-white/90 max-w-3xl mx-auto mb-8 md:mb-12">
            Don't let plumbing or electrical emergencies disrupt your life. Our expert team is ready to respond 24/7 with guaranteed arrival times.
          </p>

          <button
            onClick={handleEmergencyCall}
            className="inline-flex items-center gap-4 bg-white text-accent hover:bg-gray-100 px-8 md:px-12 py-5 md:py-6 rounded-xl font-bold text-xl md:text-2xl transition-all duration-300 shadow-elevated emergency-cta"
          >
            <Icon name="Phone" size={32} />
            <span>082 793 5785</span>
          </button>

          <p className="text-sm md:text-base text-white/80 mt-4">
            Click to call now • Available 24/7 • No call-out fees
          </p>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6 lg:gap-8 mt-12 md:mt-16">
          {responseFeatures?.map((feature, index) => (
            <div key={index} className="bg-white/10 backdrop-blur-sm rounded-xl p-4 md:p-6 border border-white/20 text-center">
              <div className="inline-flex items-center justify-center w-12 h-12 md:w-16 md:h-16 bg-white/20 rounded-full mb-3 md:mb-4">
                <Icon name={feature?.icon} size={24} />
              </div>
              
              <h3 className="text-lg md:text-xl font-bold mb-1 md:mb-2" dangerouslySetInnerHTML={{ __html: feature?.title }}></h3>
              
              <p className="text-xs md:text-sm text-white/80">
                {feature?.description}
              </p>
            </div>
          ))}
        </div>

        <div className="mt-12 md:mt-16 bg-white/10 backdrop-blur-sm rounded-2xl p-6 md:p-8 border border-white/20">
          <div className="flex flex-col md:flex-row items-center justify-between gap-6">
            <div className="flex-1 text-center md:text-left">
              <h3 className="text-xl md:text-2xl font-bold mb-2">Common Emergencies We Handle</h3>
              <div className="flex flex-wrap justify-center md:justify-start gap-2 md:gap-3">
                {["Burst Pipes", "Gas Leaks", "Electrical Faults", "Blocked Drains", "Water Heater Failures", "Power Outages"]?.map((emergency, index) => (
                  <span key={index} className="bg-white/20 px-3 py-1 rounded-full text-xs md:text-sm font-semibold">
                    {emergency}
                  </span>
                ))}
              </div>
            </div>

            <div className="flex-shrink-0">
              <div className="flex items-center gap-3 bg-white/20 px-6 py-4 rounded-xl">
                <Icon name="Clock" size={24} />
                <div>
                  <p className="text-xs md:text-sm opacity-80">Response Time</p>
                  <p className="text-lg md:text-xl font-bold">&lt;60 Minutes</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default EmergencyResponseCTA;